export enum ToastTypes {
  primary,
  warning,
  error,
  darkYellow,
}
